<template>
  <div class="page">
    <div class="content">
      <div class="title">如何修改答题设置？</div>
      <div class="first">
        <p class="way-title">
          <img
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220620/8d095cda4a2b673c1fc1290d1d96129c.svg"
            alt=""
          />用电脑创建
        </p>
        <p class="mt20">1. 复制网址在浏览器打开官网</p>
        <p
          class="blue"
          v-clipboard:copy="copyText"
          v-clipboard:success="firstCopySuccess"
          v-clipboard:error="firstCopyError"
        >
          官网网址：xiaoxiaodati.com
        </p>
        <button
          class="copy-btn"
          v-clipboard:copy="copyText"
          v-clipboard:success="firstCopySuccess"
          v-clipboard:error="firstCopyError"
        >
          一键复制网址
        </button>
        <p class="mt30">
          2.
          使用微信登录后，进入【答题管理】→找到需要修改设置的答题点击【设置】即可修改。
        </p>
      </div>
      <img
        src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20211013/986befc70730defd7e2e5bd2272a393b.png"
        class="pc-pic"
        alt=""
      />
      <p class="way-title">
        <img
          src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220620/bd3fabb40ddc8db2e45eb1f6bddb48cc.svg"
          alt=""
        />用手机创建
      </p>
      <div class="desc mt20">
        {{
          isMobile
            ? "1.点击下方按钮，进入小程序新建答题"
            : "1.微信扫描下方二维码，进入小程序"
        }}
      </div>
      <div class="finish" v-if="isMobile">
        <button class="btn" @click="toWx">前往创建答题</button>
      </div>
      <img v-else :src="src" alt="" />
      <div class="desc mt40">
        2. 点击底部的【管理】→找到【修改设置】即可调整答题的规则；
      </div>
      <img
        src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20211013/986befc70730defd7e2e5bd2272a393b.png"
        class="wechat-pic"
        alt=""
      />
      <div class="finish mt10">
        <button class="btn" @click="finishCreate">已完成设置</button>
      </div>
    </div>
    <Contact />
    <van-popup v-model="show" @closed="close">
      <div class="login-img-modal">
        <img class="login-img" :src="src" alt="" />
        <p>
          {{
            bind_status == 1
              ? "微信扫描二维码，进入小程序创建答题"
              : "微信扫码登录后，才能同步已创建的答题活动呦"
          }}
        </p>
      </div>
    </van-popup>
  </div>
</template>
<script>
import Contact from "@/components/contact";
import {
  isMobile,
  verifyAuth,
  getWxUrl,
  getDetailWxCode
} from "@/utils/common";
import { Toast } from "vant";
import api from "@/utils/api";

export default {
  components: { Contact },
  data() {
    return {
      url: "",
      isMobile: isMobile(),
      copyText: "http://xiaoxiaodati.com/",
      show: false,
      src:
        "https://cdn-xcx-qunsou.weiyoubot.cn/material/20211013/986befc70730defd7e2e5bd2272a393b.png",
      res: "",
      param: "",
      api,
      bind_status: 0
    };
  },
  methods: {
    close() {
      this.show = false;
    },
    firstCopySuccess() {
      Toast("复制成功");
    },
    firstCopyError() {
      Toast("复制失败");
    },
    async toWx() {
      let url = await getWxUrl();
      if (url) window.location.href = this.url;
    },
    async finishCreate() {
      
    },
  },
  async mounted() {
    this.qid = this.$route.query.qid || '';
    if(!this.isMobile && this.qid) { // 电脑端生成答题二维码
      let res = await getDetailWxCode(this.qid);
      this.src = res;
    }
  },
};
</script>

<style lang="scss" scoped>
@function rem($px) {
  @return $px / 75 + rem;
}
.page {
  padding: rem(20) rem(30);
  box-sizing: border-box;
  .content {
    background: #fff;
    padding: rem(30);
    border-radius: rem(8);
    font-size: rem(28);
    .title {
      font-weight: 700;
      font-size: rem(34);
      line-height: rem(51);
      text-align: center;
    }
    .desc {
      font-size: rem(28);
      line-height: rem(42);
    }
    .mt20 {
      margin-top: rem(20);
    }
    .mt30 {
      margin-top: rem(30);
    }
    .mt40 {
      margin-top: rem(40);
    }
    .finish {
      text-align: center;
      margin-top: rem(30);
      button {
        width: rem(325);
        height: rem(64);
        line-height: rem(64);
        text-align: center;
        background: #1890ff;
        color: #fff;
        font-size: rem(28);
        border-radius: rem(8);
        cursor: pointer;
      }
      &.mt10 {
        margin-top: rem(40);
      }
    }
    img {
      width: rem(350);
      height: rem(350);
      display: block;
      margin: 0 auto;
      margin-top: rem(30);
    }
  }
  .pc-pic {
    margin-bottom: rem(40) !important;
    
  }
  .wechat-pic {
    margin-top: rem(40) !important;
  }
  .first {
    line-height: rem(42);
    margin: rem(40) 0;
  }
  .way-title {
    font-weight: 700;
    font-size: rem(28);
    display: flex;
    align-items: center;
    img {
      width: rem(36);
      height: rem(36);
      display: inline-block;
      margin: 0 rem(10) 0 0;
    }
  }
  .blue {
    color: #1890ff;
  }
  .tips {
    text-align: center;
    margin-top: rem(30);
    color: #999999;
  }
  .copy-btn {
    text-align: center;
    background: #1890ff;
    color: #fff;
    font-size: rem(28);
    border-radius: rem(8);
    line-height: rem(42);
    padding: rem(10) rem(30);
    margin-top: rem(10);
    cursor: pointer;
  }
  .login-img-modal {
    text-align: center;
    font-size: rem(22);
    padding: rem(30);
    p {
      margin-top: rem(30);
      color: #999999;
      line-height: rem(30);
    }
  }
  .login-img {
    width: rem(450);
    height: rem(450);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/helpCenter/settingTip.vue